import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BSCPage.css';
import BSCImage from '../assets/marsgg.png'; // Adjust the path as necessary
const BalancedScorecardPage = () => {
  const navigate = useNavigate();
  const handleNavigate = (path) => {
    navigate(path);
    // Scroll to top after navigation
    window.scrollTo(0, 0);
  };

  return (
    <div className="bsc-page">
      <div className="bsc-hero-section">
        <div className="bsc-container">
          <h1 className="bsc-main-header">Balanced Scorecard Framework</h1>
          <div className="bsc-hero-gradient"></div>
        </div>
      </div>

      <div className="bsc-container">
        <section className="bsc-intro-section">
          <p className="bsc-intro-text">
            The Balanced Scorecard is a proven strategic management tool designed to help organisations align their activities with their vision, track performance against key goals, and improve communication across all levels. Developed by Robert Kaplan and David Norton, this powerful framework provides a balanced approach to performance management by translating strategic objectives into actionable metrics across four key areas:
          </p>
          
          <div className="bsc-scorecard-grid">
            <div className="bsc-scorecard-item financial">
              <div className="bsc-icon-container">
                <svg viewBox="0 0 24 24" className="bsc-scorecard-icon">
                  <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M11,17V16H9V14H13V13H10A1,1 0 0,1 9,12V9A1,1 0 0,1 10,8H11V7H13V8H15V10H11V11H14A1,1 0 0,1 15,12V15A1,1 0 0,1 14,16H13V17H11Z" />
                </svg>
              </div>
              <h3>1. Financial Performance</h3>
              <p>This area focuses on the organisation's financial health. Key metrics include revenue growth, cost management, and return on investment (ROI), ensuring financial goals are met alongside broader objectives.</p>
            </div>
            
            <div className="bsc-scorecard-item customer">
              <div className="bsc-icon-container">
                <svg viewBox="0 0 24 24" className="bsc-scorecard-icon">
                  <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" />
                </svg>
              </div>
              <h3>2. Customer Satisfaction</h3>
              <p>This perspective emphasises customer satisfaction and loyalty, with performance indicators like customer satisfaction scores, market share, and customer retention rates. It ensures that customer needs drive business success.</p>
            </div>
            
            <div className="bsc-scorecard-item internal">
              <div className="bsc-icon-container">
                <svg viewBox="0 0 24 24" className="bsc-scorecard-icon">
                  <path d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,12.5A1.5,1.5 0 0,1 10.5,11A1.5,1.5 0 0,1 12,9.5A1.5,1.5 0 0,1 13.5,11A1.5,1.5 0 0,1 12,12.5M6.5,11C6.5,9.67 7.17,8.5 8.23,7.73C7.62,8.37 7.25,9.2 7.25,10.13C7.25,12 8.75,13.5 10.62,13.5C11.5,13.5 12.35,13.1 12.97,12.5C12.2,13.57 11.03,14.25 9.7,14.25C7.97,14.25 6.5,12.78 6.5,11M17.5,11C17.5,12.33 16.83,13.5 15.77,14.27C16.38,13.63 16.75,12.8 16.75,11.87C16.75,10 15.25,8.5 13.38,8.5C12.5,8.5 11.65,8.9 11.03,9.5C11.8,8.43 12.97,7.75 14.3,7.75C16.03,7.75 17.5,9.22 17.5,11Z" />
                </svg>
              </div>
              <h3>3. Internal Processes</h3>
              <p>This dimension evaluates the efficiency and effectiveness of internal operations. Key metrics include process cycle times, quality measures, and rates of process improvement, helping businesses streamline workflows for optimal performance.</p>
            </div>
            
            <div className="bsc-scorecard-item learning">
              <div className="bsc-icon-container">
                <svg viewBox="0 0 24 24" className="bsc-scorecard-icon">
                  <path d="M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z" />
                </svg>
              </div>
              <h3>4. Learning and Growth</h3>
              <p>This perspective assesses the organisation's ability to innovate and develop. Metrics in this area include employee training, knowledge management, and the overall organisational culture, which are essential for long-term success and innovation.</p>
            </div>
          </div>
          
          <p className="bsc-summary-text">
            By integrating these four perspectives, the Balanced Scorecard provides a comprehensive view of organisational performance, ensuring financial success is balanced with other critical areas. It helps businesses identify areas of improvement, prioritise strategic initiatives, and track progress towards their goals.
          </p>
        </section>
        
        <section className="bsc-approach-section">
          <h2 className="bsc-section-header-1">Our Approach: Translating the Balanced Scorecard</h2>
          <div className="bsc-approach-content">
            <p>
              At Intematics, we've adapted the Balanced Scorecard framework into four key values that align with our strategic approach: Value of Business, Value of Customers, Value of Operations and Value of People. These values align with the four perspectives of financial performance, customer satisfaction, internal processes and learning and growth, offering a complete and balanced view of your business.
              
              By grounding our approach in these values, we give clients a clear, structured view of performance that helps them make informed decisions and improve outcomes across their organisation.
            </p>
           
            <img src={BSCImage} alt='BSC-image' className="BSC-image"/>
          </div>
        </section>
        
        <section className="bsc-products-section">
          <h2 className="bsc-section-header">Our Products: Empowering Your Strategy</h2>
          <p>Our products are built around the Balanced Scorecard framework, ensuring a holistic approach to organisational performance:</p>
          
          <div className="bsc-products-grid">
            <div className="product-card-tf">
              <h3>ThinkFinance</h3>
              <p>Delivers Value of Business by providing accurate P&L forecasting, bridging the gap between perception and reality. This empowers businesses to track performance and implement strategies efficiently.</p>
              <button className="bsc-learn-more-btn-tf" onClick={() => handleNavigate('/thinkfinance')}>
                Learn more
              </button>
            </div>
            
            <div className="product-card-hr">
              <h3>ThinkHR</h3>
              <p>Delivers Value of People by offering insightful snapshots of HR metrics, helping senior executives leverage data for strategic decision-making to enhance overall company performance.</p>
              <button className="bsc-learn-more-btn-hr" onClick={() => handleNavigate('/thinkhr')}>
                Learn more
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default BalancedScorecardPage;